import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import L9g20_1 from "../../assets/images/l9g20/L-9g20-1.png";

const L9g20_SPEC = () => {
  const { t, i18n } = useTranslation();
  const detailKeys = Array.from({ length: 33 }, (_, i) => `p${i + 1}`);

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={L9g20_1} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-width">
        <h2 className="spec-title">{t('accessoires.l9g20.details.title')}</h2>
        
        <ul className="spec-details">
        {detailKeys.map(key => {
          const text = t(`accessoires.l9g20.details.${key}`);
          const isTitle = text.trim().startsWith("-") && text.trim().endsWith("-");

          return (
            <li
              key={key}
              className={isTitle ? "spec-section-title" : ""}
            >
              {text.replace(/^-|-$|\s*-\s*/g, "")}
            </li>
          );
        })}
      </ul>
      </div>

    </div>
  );
};

export default L9g20_SPEC;
